module.exports = __webpack_public_path__ + "static/moneris-logo-bf415eef9fb31dce2ab1f4013a2bd3cc.png";